import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";

const Bookmarks = (props) => {
    const history = useNavigate();
    const LoginStates = useSelector(state => state.login);
    const [bookmarksList, setBookmarksList] = useState([]);

    useEffect(() => {
        getBookmarks();
    }, [])
    const getBookmarks = async () => {
        const body = {
            devUserId: LoginStates.userId
        };
        fetch(`api/Document/GetFavoriteManualFolder`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                if (resultData.data.table1.length > 0 && resultData.data.table1[0].folderItemSeq !== 0) {
                    setBookmarksList(
                        <div className="bmrk">
                            <div className="bmrk-title" onClick={() => { history('/mypage/mybookmarks') }}>
                                <h2 className="section-title">즐겨찾기한</h2>
                                <span className='section-title'>매뉴얼</span>
                                <i className="icoKdc16 seemore ico-seemore"></i>
                                {/*<div className="btn-seemore">*/}
                                {/*    <p className="p-seemore" onClick={() => { history('/mypage/mybookmarks') }}>더보기</p>*/}
                                {/*    <i className="icoKdc16 seemore"></i>*/}
                                {/*</div> */}
                            </div>
                            <ul className="bmrk-list">
                                {resultData.data.table1.slice(0, 3).map((item) => {
                                    const fullPath = JSON.parse(item.fullPath || []);
                                    if (!fullPath) return null;
                                    let category = '';
                                    if (item.location.includes("/")) {
                                        category = item.location.split("/").pop();
                                    }

                                    return (
                                        <li key={item.folderItemSeq} className="bmrk-box" onClick={() => history(item.linkPath)}>
                                            <div className="bmrk-box-cnts">
                                                <div className="bmrk-title-wrap">
                                                    <h4 className="box-cate">{category}</h4>
                                                    <h3 className="bmrk-box-title">{item.title}</h3>
                                                </div>
                                                {fullPath && (
                                                    <div className="path">
                                                        {fullPath.map((path, index) => (
                                                            <React.Fragment key={index}>
                                                                <span className="path-li">{path}</span>
                                                                {index < fullPath.length - 1 && <i className="icoKdc12 next"></i>}
                                                            </React.Fragment>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                            <button className="btn-bmrk"><i className="icoKdc48 bookmark"></i></button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    );
                }
            });
    }

    return (
        <>
            {bookmarksList}
        </>
    );
}

export default Bookmarks;